import { render, staticRenderFns } from "./VideoSessionPanel.vue?vue&type=template&id=2fc80b02&scoped=true&"
import script from "./VideoSessionPanel.vue?vue&type=script&lang=js&"
export * from "./VideoSessionPanel.vue?vue&type=script&lang=js&"
import style0 from "./VideoSessionPanel.vue?vue&type=style&index=0&id=2fc80b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc80b02",
  null
  
)

export default component.exports